import React from 'react';
import PropTypes from 'prop-types';
import '../../Resources/Fonts/fontello/css/db-markets-icons.css';
import classnames from 'classnames';

const allowedIcons = [
    'arrow-up',
    'calender',
    'check-lg',
    'check-sm',
    'chevron-down',
    'chevron-right',
    'chevron-up',
    'close',
    'doc-csv',
    'doc-pdf',
    'doc-xlsx',
    'menu-item-filled',
    'menu-item',
    'menu',
    'options',
    'plus',
    'reset',
    'switch',
    'circle',
    'triangle-down',
    'triangle-up'
];

/**
 * An icon view as a convenient way to display icons by name. It uses a custom icon font.
 */
const Icon = (props) => {

    let className = classnames('icon', 'icon-' + props.name, props.className, {
        'icon--collapsed': props.isCollapsed === true,
        'icon--small': props.isSmall === true,
        'icon--inactive': props.isInactive === true // greying out
    });

    return <i className={className}/>
};

Icon.propTypes = {
    name: PropTypes.oneOf(allowedIcons).isRequired,
    isCollapsed: PropTypes.bool,
    isSmall: PropTypes.bool,
    isInactive: PropTypes.bool,
    className: PropTypes.string
};

export default Icon;
export {allowedIcons};